import { QueryBuilder } from '@cxc/core/builders';
import { withCache } from '@ngneat/cashew';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@environments/environment';

import { API } from '@models/API';

import { platformAPI } from '@services/API/endpoints';

@Injectable({
  providedIn: 'root',
})
export class LenderAPIMatrixService {
  private http = inject(HttpClient);

  getMatrix(
    lenderId: string,
    reportedAt: string,
    currency?: string,
    loaderOptIn: boolean | string = true
  ) {
    const query = new QueryBuilder();
    query.equals('reported_at', reportedAt);
    if (currency) query.equals('currency', currency);

    return this.http.get<API.Trusts.Lender.Matrix.Response>(
      platformAPI.trusts(lenderId).lender.matrix(query),
      {
        headers: new HttpHeaders({
          'Loader-Opt-In': `${loaderOptIn}`,
          'Auth-Opt-In': 'true',
        }),
        context: withCache({
          ttl: environment.CACHE_LIFETIME,
        }),
      }
    );
  }
}
